import { render, staticRenderFns } from "./MultipleSelection.vue?vue&type=template&id=664295b6&scoped=true"
import script from "./MultipleSelection.vue?vue&type=script&lang=js"
export * from "./MultipleSelection.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelection.vue?vue&type=style&index=0&id=664295b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664295b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664295b6')) {
      api.createRecord('664295b6', component.options)
    } else {
      api.reload('664295b6', component.options)
    }
    module.hot.accept("./MultipleSelection.vue?vue&type=template&id=664295b6&scoped=true", function () {
      api.rerender('664295b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/MultipleSelection.vue"
export default component.exports